const d = (p, a) => p.reduce(
  (n, c) => {
    const o = a(c);
    return (n[o] || (n[o] = [])).push(c), n;
  },
  {}
);
export {
  d as default
};
